import { render } from "./Years.vue?vue&type=template&id=dfa633f0"
import script from "./Years.vue?vue&type=script&lang=ts"
export * from "./Years.vue?vue&type=script&lang=ts"
script.render = render

export default script